import objectKeysToCamel from 'utils/object/objectKeysToCamel';
import {getActualRouter} from 'router/utils/defineActualRouter';


export default function getRouteHref (name, params, queryParams = {}) {
  const router = getActualRouter();
  const convertedParams = objectKeysToCamel(params);
  const route = router.resolve(
    {
      name,
      params: convertedParams,
      query: queryParams
    }
  );

  return route.href;
}
